import React, { Component } from 'react';
import classNames from 'classnames';
import Checkbox from '../../../../components/forms/checkbox';
import { applyChainFilter } from '../../helpers/filters/filter-helpers';

class ChainGroup extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            checked: props.selected,
            isVisible: false
        }

    }

    componentDidMount() {
        this.props.registerChainGroupComponent(this);
    }

    handleChange() {
        this.setState({
            checked: !this.state.checked
        }, () => {
            this.props.toggleAllChildren(this.props.chainGroupCode, this.state.checked);
        });
    }

    toggleVisible() {
        this.setState({
            isVisible: !this.state.isVisible
        });
    }

    reset() {
        this.setState({
            checked: true
        });
    }

    render() {
        return (
            <li>
                <label>
                    <Checkbox type="checkbox" 
                            checked={this.state.checked} 
                            onChange={() => this.handleChange()} /> {this.props.chainGroupName}
                </label>
                <button className={classNames({
                    'map-filters__chain-toggler': true,
                    'map-filters__chain-toggler--is-open': this.state.isVisible
                })} type="button" onClick={() => this.toggleVisible()}></button>
                <Chain {...this.props} isVisible={this.state.isVisible} />
            </li>
        );
        
    }
}

class Chain extends Component {
    render() {
        return (
            <ul className={classNames({
                'map-filters__chain': true,
                'map-filters__chain--is-visible': this.props.isVisible
            })}>
                {this.props.chains.filter(({ chainGroupCode }) => chainGroupCode === this.props.chainGroupCode).map(chain => {
                    return (
                        <li key={chain.chainCode}>
                            <label>
                                <Checkbox type="checkbox" checked={chain.selected} onChange={() => this.props.toggleSelected(chain.chainCode, !chain.selected)} /> {chain.chainName}
                            </label>
                        </li>
                    );
                })}
            </ul>
        );
    }
}

class Chains extends Component {

    chainGroupComponents = [];
    state = {
        chains: null,
        chainGroups: null
    };

    registerChainGroupComponent(comp) {
        this.chainGroupComponents.push(comp);
    }

    isChainGroupSelected(chains, chainGroupCode) {
        return chains.find(chain => chain.selected && chain.chainGroupCode === chainGroupCode ? true : false) ? true : false;
    }

    getChainGroups(chains) {
        const groups = [];

        chains.forEach(group => {
            if (!groups.find(g => g.chainGroupCode === group.chainGroupCode)) {
                groups.push({
                    chainGroupName: group.chainGroupName,
                    chainGroupCode: group.chainGroupCode,
                    selected: this.isChainGroupSelected(chains, group.chainGroupCode)
                });
            }
        });

        return groups;
    }
    
    toggleAllChildren(chainGroupCode, selected) {
        const chains = this.state.chains.map(chain => {
            if (chainGroupCode === chain.chainGroupCode) {
                return {
                    ...chain,
                    selected
                }
            }
            
            return chain;
        });

        this.setState({
            chains
        }, () => {
            this.props.previewFilter();
        });
    }

    toggleSelected(chainCode, selected) {
        const chains = this.state.chains.map(chain => {
            if (chainCode === chain.chainCode) {
                return {
                    ...chain,
                    selected
                }
            }

            return chain;
        });
        
        this.setState({
            chains
        }, () => {
            this.props.previewFilter();
        });
    }

    filter(units) {
        const chains = this.state.chains || this.props.filters.chains;
        const filteredUnits = applyChainFilter(units, chains);
        return {
            filteredUnits, 
            filter: {
                chains
            }
        };
    }

    componentDidMount() {
        const { filters } = this.props;
        
        this.setState({
            chains: filters.chains,
            chainGroups: this.getChainGroups(filters.chains)
        }, () => {
            this.props.registerFilter(this);
        });
    }

    reset() {
        const chains = this.state.chains.map(chain => {
            return ({
                ...chain,
                selected: true
            });
        });

        const chainGroups = this.state.chainGroups.map(group => {
            return ({
                ...group,
                selected:true
            });
        });

        this.setState({
            chains,
            chainGroups
        }, (() => {
            this.chainGroupComponents.forEach(chainGroupComp => {
                chainGroupComp.reset();
            });
        }));
    }

    getPropertyName() {
        return this.props.propertyName;
    }

    getValues() {
        return this.state.chains;
    }

    render() {

        const { chains, chainGroups } = this.state;

        return (
            <div className="map-filters__filter">
                <h2 className="map-filters__filter-heading">Kedjor</h2>
                <ul className="map-filters__chains">
                    {chainGroups && chainGroups.map(g => {
                        return (
                            <ChainGroup {...g} 
                                        registerChainGroupComponent={(comp) => this.registerChainGroupComponent(comp)}
                                        chains={chains} 
                                        toggleSelected={(chainCode, selected) => this.toggleSelected(chainCode, selected)}
                                        toggleAllChildren={(chainGroupCode, selected) => this.toggleAllChildren(chainGroupCode, selected)} 
                                        key={g.chainGroupCode} />
                        );
                    })}
                </ul>
            </div>
        );
    }
};

export default Chains;